<template>
    <div class="truncate" :title="props.displayName ?? undefined">
        <vx-popover hover :arrow="true" placement="top">
            <vx-badge color="slate" size="xs" class="font-mono" data-test="brand-id">
                {{ props.brandId }}
            </vx-badge>
            <template v-slot:content>
                <kiosk-tcr-brand-vetting-card
                    :verified="props.verified"
                    :vettingScore="props.vettingScore"
                    :entityType="props.entityType"
                    :vettingClass="props.vettingClass"
                    :vettingStatus="props.vettingStatus"
                ></kiosk-tcr-brand-vetting-card>
            </template>
        </vx-popover>
        <span class="ml-2 text-xs font-bold" data-test="brand-name">{{ props.displayName || '—' }}</span>
    </div>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover } from '@voxie/frontend-components';
import KioskTcrBrandVettingCard from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrBrandVettingCard.vue';
import type { TcrEntityType, TcrVettingClass, TcrVettingStatus } from '~/services/adminTenDlcClient.types';

const props = defineProps<{
    brandId: string;
    displayName: string | null;
    verified: boolean | null;
    vettingScore: number | null;
    entityType: TcrEntityType | null;
    vettingClass: TcrVettingClass | null;
    vettingStatus: TcrVettingStatus | null;
}>();
</script>
